module.exports = __webpack_public_path__ + "assets/media/plus_one_people.64cf1bbe.svg";